<template>
	<div class="Content">
		<preloader v-bind:show="show"></preloader>

		<div class="img bcg-img"
				 v-bind:style="{ backgroundPositionX: pos + '%' }">
			<div class="nav-block" v-bind:class="{ showNav: show }">
				<a href="#" v-on:click="posfunc(1)" :class="{ active:isActive(1) }">Company</a>
				<a href="#" v-on:click="posfunc(2)" :class="{ active:isActive(2) }">Freestyle</a>
				<a href="#" v-on:click="posfunc(3)" :class="{ active:isActive(3) }">Freeride</a>
				<a href="#" v-on:click="posfunc(4)" :class="{ active:isActive(4) }">Universal</a>
				<a href="#" v-on:click="posfunc(5)" :class="{ active:isActive(5) }">Contacts</a>
				<a href="https://en.phantom.equipment" :class="{ active:isActive(6) }">ENG</a>
			</div>
			<Logo v-bind:show="show" v-bind:active="activeItem"></Logo>
		</div>

		<img class="blur" src="../assets/blur.png" alt="" :class="{ showBlur:isBlur(2) }">
		<img class="blur" src="../assets/blur.png" alt="" :class="{ showBlur:isBlur(3) }">
		<img class="blur" src="../assets/blur.png" alt="" :class="{ showBlur:isBlur(4) }">

		<div class="mainContent" v-bind:class="{ display:displayMain() }">
			<leftBlock v-bind:active="activeItem"></leftBlock>
			<board v-bind:active="activeItem"></board>
			<rightBlock v-bind:active="activeItem"></rightBlock>
			<blackLogo class="logo-black" v-bind:active="activeItem"></blackLogo>

			<div class="text-wrapper" style="margin: 90px auto 0;">
				<template v-if="isActive(2)">
					<h3 class="mainPage-text text-header">Freestyle</h3>
					<p class="mainPage-text mainPage-bottom text-content">Phantom T — машина для бэккантти-фристайла, на которой можно уверенно прыгать как с пушистых дропов, так и в парке. Классический кембер в сочетании с умеренными рокерами на носу и хвосте, позволяет этому твин-типу иметь отличную отдачу на жестком склоне и всплывать в пухляке. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.</p>
				</template>
				<template v-if="isActive(3)">
					<h3 class="mainPage-text text-header">Freeride</h3>
					<p class="mainPage-text mainPage-bottom text-content">Phantom F – истребитель снежных пространств последнего поколения. Жесткий, быстрый и маневренный он не потопляем в глубоком снегу и режет, как масло, леденистые склоны. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.</p>
				</template>
				<template v-if="isActive(4)">
					<h3 class="mainPage-text text-header">Universal</h3>
					<p class="mainPage-text mainPage-bottom text-content">Phantom U – многоцелевая машина, способная раскрыть возможности самого опытного пилота. Жесткая трасса, глубокий снег, гигантские дропы — на него можно положиться в любых условиях. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.</p>
				</template>
			</div>

		</div>

		<div class="mainPage" v-bind:class="{ displayMain:displayMainPage() }">
			<p class="mainPage-text mainPage-header">COMPANY</p>
			<p class="mainPage-text">Путь к совершенству лежит через преодоление невозможного</p>
			<br/>
			<p class="mainPage-text">Вчера мы осваивали технологии известных производителей, чтобы создать сноуборды
				мирового уровня — сегодня мы используем собственные технологии и подходы, чтобы
				быть на высоте. Мы создали Phantom — точный инструмент, оставляющий безупречный
				след на любом рельефе. Спроектированные инженерами и учёными Новосибирского
				академгородка, собранные профессионалами из лучших материалов, сноуборды Phantom
				готовы раскрыть твой потенциал на 100%.</p>

			<p class="mainPage-text mainPage-header">Carbon AERO</p>
			<p class="mainPage-text mainPage-subheader">Carbon Alloy Epoxy Resin</p>
			<p class="mainPage-text">Изгибы, удары и вибрации медленно разрушают материалы изнутри. Чтобы Phantom
				служил дольше и был твоим надёжным напарником в самых экстремальных условиях,
				мы используем эпоксидную смолу, обогащенную углеродными нанотрубками.
				Встраиваясь в полимерную матрицу смолы, нанотрубки препятствуют росту
				микротрещин, что делает конструкцию долговечнее. Эту задачу мы решили в
				сотрудничестве с OCSiAl, мировым лидером производства углеродных нанотрубок.
				Carbon AERO — новый уровень композитных систем.</p>
			<p class="mainPage-text mainPage-header">KEEN System</p>
			<p class="mainPage-text mainPage-subheader">Kevlar Edge ENhancement System</p>
			<p class="mainPage-text mainPage-bottom">Мягкий белоснежный склон нередко скрывает острые камни, которые могут испортить
				твоё снаряжение. Сноуборд с вырванным кантом чаще всего отправляется на свалку.
				Чтобы твой отдых не омрачил досадный случай, мы связываем стальные канты по всей их
				длине прочными кевларовыми нитями. KEEN System — твоя уверенность в каждой дуге.</p>
			<blackLogo style="margin-bottom: 5px"></blackLogo>
                        <p class="mainPage-text mainPage-subheader"><a class="mainPage-link" href="https://fasie.ru/"><img src="../assets/f.jpg" width="180" height="120"></img></a></p>
		</div>

		<div class="contact" v-if="isActive(5)">
			<p class="mainPage-text"><a class="mainPage-link" href="mailto:hi@phantom.equipment">hi@phantom.equipment</a></p>
			<p class="mainPage-text"><a class="mainPage-link" href="mailto:sales@phantom.equipment">sales@phantom.equipment</a></p>
			<p class="mainPage-text">ООО «Техноресурс»</p>
			<p class="mainPage-text">Юридический адрес: 630090, г. Новосибирск, ул. Инженерная, 16</p>
			<p class="mainPage-text">Почтовый адрес: 630090, г. Новосибирск, ул. Инженерная, 16</p>
			<p class="mainPage-text">Тел:&nbsp;
				<a class="mainPage-link" href="tel:+79139274951">+7 913 927-49-51</a>,
				<a class="mainPage-link" href="tel:+79232226828">+7 923 222-68-28</a>,
			</p>
			<p class="mainPage-text">ИНН: 5408283940</p>
			<p class="mainPage-text">КПП: 540801001</p>
			<p class="mainPage-text">ОГРН: 1105476084526</p>
			<p class="mainPage-text">р/с: 40702810502020050096 В ПАО Банка «ФК ОТКРЫТИЕ»</p>
			<p class="mainPage-text">к/сч: 30101810100000000867</p>
			<p class="mainPage-text">БИК: 04500486</p>
                                <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
			<blackLogo style="margin-bottom: 5px"></blackLogo>
                        <p class="mainPage-text mainPage-subheader"><a class="mainPage-link" href="https://fasie.ru/"><img src="../assets/f.jpg" width="180" height="120"></img></a></p>
			</p>
		</div>

		<footerComponent></footerComponent>
	</div>
</template>

<script>
  import Logo from './Logo'
  import Preloader from './Preloader'
  import board from './board'
  import rightBlock from './RightBlock'
  import leftBlock from './LeftBlock'
  import footerComponent from './footerComponent'
  import blackLogo from './blackLogo'

  export default {
    name: 'Content',
    props: ['active', 'change'],
    data () {
      return {
        activeItem: 1,
        show: false,
        isShow: false,
        isDisplay: false,
        pos: 0
      }
    },
    components: {
      Logo,
      Preloader,
      board,
      rightBlock,
      leftBlock,
      blackLogo,
      footerComponent
    },
    methods: {
      displayMainPage: function () {
        return this.activeItem !== 1
      },
      displayMain: function () {
        return this.activeItem === 1 || this.activeItem === 5
      },
      posfunc: function (index) {
        var width = $(window).width();
        let prev = this.activeItem
        let diff = 0
        if (prev > index) {
          if (prev === 5 && index === 1) {
            diff = -999
          } else {
            diff = -( prev - index )
          }
        } else if (prev < index) {
          diff = index - prev
        }
        if (width >= 1250) {
        if (diff === -999) {
          this.pos = 0
        } else {
          this.pos = this.pos + ( diff * 25 )
        }
        }
        this.activeItem = index
      },
      isActive: function (index) {
        return this.activeItem === index
      },
      isBlur: function (i) {
        return this.activeItem === i
      }
    },
    created() {
      let self = this
      window.addEventListener('load', function () {
        setTimeout(function () {
					window.scrollTo(0, 0);
					self.show = true
        }, 0)
      })
    },
    watch: {
      change: function () {
        let index = this.activeItem
        if (this.active > 0 && index !== 5) {
          index++
          this.posfunc(index)
        } else if (this.active < 0 && index !== 1) {
          index--
          this.posfunc(index)
        } else if (index === 5) {
          index = 1
          this.posfunc(index)
        } else if (index === 1) {
          index = 5
          this.posfunc(index)
        }
      }
    }
  }
</script>

<style scoped>

	.blur {
		position: absolute;
		top: -152px;
		margin: 0 auto;
		left: 0;
		right: 0;
		z-index: 15;
		opacity: 0;
	}

	.mainPage {
		text-align: left;
		padding-top: 40px;
	}

	.mainPage-link {
		color: #000000;
	}

	.mainPage-text {
		font-family: opinionprocondensed, serif;
		color: #000000;
		font-size: 24px;
		font-weight: 300;
		line-height: 32px;
		text-align: left;
		max-width: 660px;
		margin: 0 auto;
	}

	.mainPage-header {
		color:  #1a1a1a;
		font-size: 36px;
		font-weight: 300;
		font-style: italic;
		line-height: 23.25px;
		text-align: center;
		margin-top: 88px;
		margin-bottom: 19px;
	}

	.mainPage-subheader {
		color:  #1a1a1a;
		font-size: 24px;
		font-weight: 300;
		font-style: italic;
		text-align: center;
		line-height: 23.25px;
		margin-bottom: 61px;
	}

	.text-header {
		color:  #1a1a1a;
		font-size: 32px;
		font-weight: 400;
		text-align: center;
		line-height: 23.25px;
		margin-bottom: 19px;
	}

	.mainPage-bottom {
		margin-bottom: 73px;
	}

	.logo-black {
		margin-bottom: -75px;
	}

	.showBlur {
		opacity: .7;
		transition: opacity ease-out 2s;
	}

	.Content {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
	}

	.unload {
		opacity: 0;
		visibility: hidden;
		transition: all .6s;
	}

	.img {
		background-image: url('./../assets/back.jpg');
	}

	.bcg-img {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background-color: #333333;
		background-size: 310%;
		height: 550px;
		background-position-x: 0;
		background-position-y: 5%;
		transition: background-position .6s;
	}

	.load {
		opacity: 1;
	}

	.Logo {
		z-index: 999;
	}

	.nav-block {
		margin: 23px auto 0;
		width: 500px;
		font-family: opinionpro, serif;
		display: flex;
		justify-content: space-between;
		align-items: center;
		opacity: 0;
		z-index: 90;
	}

	.showNav {
		opacity: 1;
	}

	.contact {
		margin: 60px 20px;
	}

	.nav-block > a {
		position: relative;
		text-transform: uppercase;
		font-size: 18px;
		font-family: opinionprocondensed, serif;
		color: #fff;
		text-decoration: none;
		outline: none;
		padding: 10px 0;
	}

	a:after, a:before {
		position: absolute;
		opacity: 0;
		width: 0;
		height: 1px;
		content: '';
		background: #fff;
		transition: all 0.7s;
	}

	a:after {
		left: 0px;
		top: 0px;
	}

	a:before {
		right: 0px;
		bottom: 0px;
	}

	a.active:before {
		opacity: 1;
		width: 100%;
	}

	a.active:after {
		opacity: 1;
		width: 100%;
	}

	.mainContent {
		display: flex;
		flex-wrap: wrap;
		width: auto;
		height: 45%;
		background-color: #fafafa;
		border-top: solid 1px #e6e6e6;
		padding: 0 12%;
	}

	.display {
		height: 0;
		visibility: hidden;
		padding: 0;
		overflow-x: hidden;
	}
	.displayMain {
		height: 0;
		visibility: hidden;
		padding: 0;
		display: none;
	}
	@media all and (max-width: 1600px) {
		.mainContent {
			padding: 0 10%;
		}
	}

	@media all and (max-width: 1500px) {
		.mainContent {
			padding: 0 8%;
		}
	}

	@media all and (max-width: 1400px) {
		.mainContent {
			padding: 0 6%;
		}
	}

	@media all and (max-width: 1350px) {
		.mainContent {
			padding: 0 4%;
		}
	}

	@media all and (max-width: 1250px) {
		.mainPage {
			padding-left: 4%;
			padding-right: 4%;
		}

		.img {
			background-image: url('./../assets/back-android.jpg');
		}

		.bcg-img {
			height: 414px;
			background-position-x: 0;
			background-position-y: 0;
			background-size: cover;
		}

		.mainContent {
			flex-direction: column;
			align-items: center;
		}

		.mainContent .left-block {
			order: 2;
			max-width: 100%;
		}

		.right-block {
			order: 3;
		}

		.logo-block {
			order: 4;
		}

		.nav-block {
			z-index: 10;
			width: 330px;
		}

		.nav-block > a {
			font-size: 13px;
		}

		.blur {
			top: 103px;
			width: 300px;
		}

		.text-wrapper {
			width: 290px;
			order: 3;
		}

		.text-header {
			font-size: 28px;
			font-weight: 500px;
		}

		.text-content {
			font-size: 20px;
			line-height: 24px;
		}

		.logo-black {
			margin: 32px;
		}

	}


</style>



// WEBPACK FOOTER //
// src/components/Content.vue?2cb2a899